/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { VehicleCommandType } from './VehicleCommandType';
export type VehicleCommand = {
    command?: VehicleCommandType | null;
    created_at: string;
    /**
     * 0 = outbound (command sent to vehicle), 1 = inbound (reply from vehicle)
     */
    direction: VehicleCommand.direction;
    is_service: boolean;
    status?: VehicleCommand.status | null;
};
export namespace VehicleCommand {
    /**
     * 0 = outbound (command sent to vehicle), 1 = inbound (reply from vehicle)
     */
    export enum direction {
        '_0' = 0,
        '_1' = 1,
    }
    export enum status {
        FAILED = 'failed',
        QUEUED = 'queued',
        SENT = 'sent',
        CONFIRMED = 'confirmed',
        TIMEOUT = 'timeout',
        NO_ACTION = 'no_action',
    }
}

